export default "__VITE_ASSET__aebb3d42__"